<template>
  <!-- 文本二次封装
      @author: liuguisheng
      @date: 2019-9-13
  -->
  <div v-if="isDisplay && showRule!=='render'"
        class="preview-item_text"
        :style="{ 
          width,
          fontSize: title + 'px',
          fontWeight: wordWeight,
          color: color,
          'padding-left':paddingLeft
        }">
        {{labelName}}
  </div>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";


export default {
  mixins: [ mixPreviewItemTemplateChild ]
}

</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemText.vue